import { useEffect } from 'react'
import { client } from '~/api/client'
import { postFoldersFolderIdReceivesV1 } from '~/api/gen'
import { assertSuccess } from '~/lib/assertSuccess'
import { isNetworkError } from '~/lib/isNetworkError'

const postPvCount = (folderId: number) => {
  return postFoldersFolderIdReceivesV1(client, {
    parameter: { folder_id: folderId },
    requestBody: { uuid: crypto.randomUUID() },
  }).then(
    (res) => {
      assertSuccess(res)
    },
    (e) => {
      // ignore (network error)
      if (isNetworkError(e)) return undefined
      // re-throw
      throw new Error(`Failed to post pv count`, { cause: e })
    }
  )
}

export const usePvCount = (folderId: number) => {
  useEffect(() => {
    postPvCount(folderId)
  }, [folderId])
}
